import React5 from 'react';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

// src/next/core/Button.tsx
var _injected = false;
function ensureStyles() {
  if (_injected || typeof document === "undefined") return;
  _injected = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "button");
  el.textContent = `
  .ramos-btn{
    --_bg:var(--brand);--_bgh:var(--brand-hover);--_bga:var(--brand-active);
    --_fg:var(--text-inverse);--_bd:transparent;
    display:inline-flex;align-items:center;justify-content:center;gap:var(--space-4);
    font-family:var(--font-sans);font-weight:var(--weight-medium);
    border:var(--border-hairline) solid var(--_bd);border-radius:var(--radius-sm);
    background:var(--_bg);color:var(--_fg);cursor:pointer;white-space:nowrap;
    height:var(--control-md);padding:0 var(--space-6);font-size:var(--text-base);
    transition:var(--transition-colors), box-shadow var(--duration-fast) var(--ease-standard), transform var(--duration-instant) var(--ease-standard);
    user-select:none;text-decoration:none;line-height:1;
  }
  .ramos-btn:hover{background:var(--_bgh);}
  .ramos-btn:active{background:var(--_bga);transform:translateY(0.5px);}
  .ramos-btn:focus-visible{outline:none;box-shadow:var(--ring);}
  .ramos-btn[disabled]{opacity:0.45;cursor:not-allowed;transform:none;}
  .ramos-btn--sm{height:var(--control-sm);padding:0 var(--space-5);font-size:var(--text-sm);}
  .ramos-btn--lg{height:var(--control-lg);padding:0 var(--space-7);font-size:var(--text-md);}
  .ramos-btn--full{width:100%;}
  .ramos-btn--secondary{--_bg:var(--surface-card);--_bgh:var(--surface-hover);--_bga:var(--surface-active);--_fg:var(--text-body);--_bd:var(--border-default);}
  .ramos-btn--ghost{--_bg:transparent;--_bgh:var(--surface-hover);--_bga:var(--surface-active);--_fg:var(--text-body);--_bd:transparent;}
  .ramos-btn--accent{--_bg:var(--accent);--_bgh:var(--accent-hover);--_bga:var(--cashew-800);--_fg:#fff;}
  .ramos-btn--danger{--_bg:var(--red-600);--_bgh:var(--red-700);--_bga:#8a2825;--_fg:#fff;}
  .ramos-btn__spin{width:14px;height:14px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:ramos-spin .6s linear infinite;}
  @keyframes ramos-spin{to{transform:rotate(360deg)}}
  .ramos-btn__icon{display:inline-flex;align-items:center;justify-content:center;}
  `;
  document.head.appendChild(el);
}
function Button({
  variant = "primary",
  size = "md",
  leftIcon,
  rightIcon,
  loading = false,
  fullWidth = false,
  disabled = false,
  className = "",
  children,
  ...rest
}) {
  ensureStyles();
  const cls = [
    "ramos-btn",
    variant !== "primary" && `ramos-btn--${variant}`,
    size !== "md" && `ramos-btn--${size}`,
    fullWidth && "ramos-btn--full",
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsxs("button", { className: cls, disabled: disabled || loading, ...rest, children: [
    loading && /* @__PURE__ */ jsx("span", { className: "ramos-btn__spin", "aria-hidden": "true" }),
    !loading && leftIcon && /* @__PURE__ */ jsx("span", { className: "ramos-btn__icon", children: leftIcon }),
    children,
    !loading && rightIcon && /* @__PURE__ */ jsx("span", { className: "ramos-btn__icon", children: rightIcon })
  ] });
}
var _injected2 = false;
function ensureStyles2() {
  if (_injected2 || typeof document === "undefined") return;
  _injected2 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "icon-button");
  el.textContent = `
  .ramos-iconbtn{
    --_bg:transparent;--_bgh:var(--surface-hover);--_bga:var(--surface-active);
    --_fg:var(--text-muted);--_bd:transparent;
    display:inline-flex;align-items:center;justify-content:center;
    width:var(--control-md);height:var(--control-md);
    border:var(--border-hairline) solid var(--_bd);border-radius:var(--radius-sm);
    background:var(--_bg);color:var(--_fg);cursor:pointer;flex:none;
    transition:var(--transition-colors), box-shadow var(--duration-fast) var(--ease-standard);
  }
  .ramos-iconbtn:hover{background:var(--_bgh);color:var(--text-body);}
  .ramos-iconbtn:active{background:var(--_bga);}
  .ramos-iconbtn:focus-visible{outline:none;box-shadow:var(--ring);}
  .ramos-iconbtn[disabled]{opacity:0.4;cursor:not-allowed;}
  .ramos-iconbtn--sm{width:var(--control-sm);height:var(--control-sm);}
  .ramos-iconbtn--lg{width:var(--control-lg);height:var(--control-lg);}
  .ramos-iconbtn--outline{--_bd:var(--border-default);--_bg:var(--surface-card);}
  .ramos-iconbtn--solid{--_bg:var(--brand);--_bgh:var(--brand-hover);--_bga:var(--brand-active);--_fg:#fff;}
  .ramos-iconbtn--solid:hover{color:#fff;}
  `;
  document.head.appendChild(el);
}
function IconButton({
  variant = "ghost",
  size = "md",
  label,
  className = "",
  children,
  ...rest
}) {
  ensureStyles2();
  const cls = [
    "ramos-iconbtn",
    variant !== "ghost" && `ramos-iconbtn--${variant}`,
    size !== "md" && `ramos-iconbtn--${size}`,
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx("button", { className: cls, "aria-label": label, title: label, ...rest, children });
}
var _injected3 = false;
function ensureStyles3() {
  if (_injected3 || typeof document === "undefined") return;
  _injected3 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "input");
  el.textContent = `
  .ramos-field{display:flex;flex-direction:column;gap:var(--space-3);font-family:var(--font-sans);}
  .ramos-field__label{font:var(--font-label);color:var(--text-body);}
  .ramos-field__req{color:var(--red-600);margin-left:2px;}
  .ramos-field__hint{font-size:var(--text-xs);color:var(--text-muted);}
  .ramos-field__hint--err{color:var(--red-600);}
  .ramos-input-wrap{position:relative;display:flex;align-items:center;}
  .ramos-input{
    width:100%;height:var(--control-md);
    padding:0 var(--space-5);font-family:var(--font-sans);font-size:var(--text-base);
    color:var(--text-strong);background:var(--surface-card);
    border:var(--border-hairline) solid var(--border-default);border-radius:var(--radius-md);
    transition:var(--transition-colors), box-shadow var(--duration-fast) var(--ease-standard);
    box-shadow:var(--shadow-inset);
  }
  .ramos-input::placeholder{color:var(--text-subtle);}
  .ramos-input:hover{border-color:var(--border-strong);}
  .ramos-input:focus{outline:none;border-color:var(--border-focus);box-shadow:var(--ring);}
  .ramos-input[disabled]{background:var(--surface-sunken);color:var(--text-muted);cursor:not-allowed;}
  .ramos-input--mono{font-family:var(--font-mono);letter-spacing:0.01em;}
  .ramos-input--sm{height:var(--control-sm);font-size:var(--text-sm);}
  .ramos-input--lg{height:var(--control-lg);}
  .ramos-input--err{border-color:var(--red-500);}
  .ramos-input--err:focus{box-shadow:0 0 0 3px var(--red-100);}
  .ramos-input--hasleft{padding-left:34px;}
  .ramos-input--hasright{padding-right:34px;}
  .ramos-input__icon{position:absolute;display:flex;align-items:center;color:var(--text-subtle);pointer-events:none;}
  .ramos-input__icon--l{left:10px;}
  .ramos-input__icon--r{right:10px;}
  `;
  document.head.appendChild(el);
}
function Input({
  label,
  hint,
  error,
  required = false,
  size = "md",
  mono = false,
  leftIcon,
  rightIcon,
  id,
  className = "",
  ...rest
}) {
  ensureStyles3();
  const fid = id || (label ? `in-${label.replace(/\s+/g, "-").toLowerCase()}` : void 0);
  const inputCls = [
    "ramos-input",
    mono && "ramos-input--mono",
    size !== "md" && `ramos-input--${size}`,
    error && "ramos-input--err",
    leftIcon && "ramos-input--hasleft",
    rightIcon && "ramos-input--hasright",
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsxs("div", { className: "ramos-field", children: [
    label && /* @__PURE__ */ jsxs("label", { className: "ramos-field__label", htmlFor: fid, children: [
      label,
      required && /* @__PURE__ */ jsx("span", { className: "ramos-field__req", children: "*" })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "ramos-input-wrap", children: [
      leftIcon && /* @__PURE__ */ jsx("span", { className: "ramos-input__icon ramos-input__icon--l", children: leftIcon }),
      /* @__PURE__ */ jsx("input", { id: fid, className: inputCls, "aria-invalid": !!error, ...rest }),
      rightIcon && /* @__PURE__ */ jsx("span", { className: "ramos-input__icon ramos-input__icon--r", children: rightIcon })
    ] }),
    (hint || error) && /* @__PURE__ */ jsx("span", { className: `ramos-field__hint${error ? " ramos-field__hint--err" : ""}`, children: error || hint })
  ] });
}
var _injected4 = false;
function ensureStyles4() {
  if (_injected4 || typeof document === "undefined") return;
  _injected4 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "select");
  el.textContent = `
  .ramos-select-wrap{position:relative;display:flex;align-items:center;font-family:var(--font-sans);}
  .ramos-select{
    appearance:none;-webkit-appearance:none;width:100%;height:var(--control-md);
    padding:0 32px 0 var(--space-5);font-family:var(--font-sans);font-size:var(--text-base);
    color:var(--text-strong);background:var(--surface-card);cursor:pointer;
    border:var(--border-hairline) solid var(--border-default);border-radius:var(--radius-md);
    transition:var(--transition-colors), box-shadow var(--duration-fast) var(--ease-standard);
    box-shadow:var(--shadow-inset);
  }
  .ramos-select:hover{border-color:var(--border-strong);}
  .ramos-select:focus{outline:none;border-color:var(--border-focus);box-shadow:var(--ring);}
  .ramos-select[disabled]{background:var(--surface-sunken);color:var(--text-muted);cursor:not-allowed;}
  .ramos-select--sm{height:var(--control-sm);font-size:var(--text-sm);}
  .ramos-select__chev{position:absolute;right:10px;pointer-events:none;color:var(--text-subtle);display:flex;}
  `;
  document.head.appendChild(el);
}
function Select({
  options = [],
  size = "md",
  placeholder,
  className = "",
  children,
  ...rest
}) {
  ensureStyles4();
  const cls = ["ramos-select", size !== "md" && `ramos-select--${size}`, className].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsxs("div", { className: "ramos-select-wrap", children: [
    /* @__PURE__ */ jsxs("select", { className: cls, ...rest, children: [
      placeholder && /* @__PURE__ */ jsx("option", { value: "", disabled: true, children: placeholder }),
      children || options.map((o) => {
        const opt = typeof o === "string" ? { value: o, label: o } : o;
        return /* @__PURE__ */ jsx("option", { value: opt.value, children: opt.label }, opt.value);
      })
    ] }),
    /* @__PURE__ */ jsx("span", { className: "ramos-select__chev", "aria-hidden": "true", children: /* @__PURE__ */ jsx(
      "svg",
      {
        "aria-hidden": "true",
        width: "14",
        height: "14",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /* @__PURE__ */ jsx("polyline", { points: "6 9 12 15 18 9" })
      }
    ) })
  ] });
}
var _injected5 = false;
function ensureStyles5() {
  if (_injected5 || typeof document === "undefined") return;
  _injected5 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "checkbox");
  el.textContent = `
  .ramos-check{display:inline-flex;align-items:center;gap:var(--space-4);font-family:var(--font-sans);font-size:var(--text-base);color:var(--text-body);cursor:pointer;user-select:none;}
  .ramos-check input{position:absolute;opacity:0;width:0;height:0;}
  .ramos-check__box{
    width:18px;height:18px;flex:none;border-radius:var(--radius-xs);
    border:var(--border-thick) solid var(--border-strong);background:var(--surface-card);
    display:flex;align-items:center;justify-content:center;color:#fff;
    transition:var(--transition-colors), box-shadow var(--duration-fast) var(--ease-standard);
  }
  .ramos-check__box svg{opacity:0;transform:scale(0.6);transition:opacity var(--duration-fast) var(--ease-out), transform var(--duration-fast) var(--ease-out);}
  .ramos-check:hover .ramos-check__box{border-color:var(--brand);}
  .ramos-check input:checked + .ramos-check__box{background:var(--brand);border-color:var(--brand);}
  .ramos-check input:checked + .ramos-check__box svg{opacity:1;transform:scale(1);}
  .ramos-check input:indeterminate + .ramos-check__box{background:var(--brand);border-color:var(--brand);}
  .ramos-check input:focus-visible + .ramos-check__box{box-shadow:var(--ring);}
  .ramos-check input:disabled + .ramos-check__box{background:var(--surface-sunken);border-color:var(--border-default);}
  .ramos-check--disabled{color:var(--text-muted);cursor:not-allowed;}
  `;
  document.head.appendChild(el);
}
function Checkbox({
  label,
  checked,
  indeterminate = false,
  disabled = false,
  className = "",
  ...rest
}) {
  ensureStyles5();
  const ref = React5.useRef(null);
  React5.useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate;
  }, [indeterminate]);
  return /* @__PURE__ */ jsxs("label", { className: `ramos-check${disabled ? " ramos-check--disabled" : ""} ${className}`, children: [
    /* @__PURE__ */ jsx("input", { ref, type: "checkbox", checked, disabled, ...rest }),
    /* @__PURE__ */ jsx("span", { className: "ramos-check__box", "aria-hidden": "true", children: indeterminate ? /* @__PURE__ */ jsx(
      "svg",
      {
        "aria-hidden": "true",
        width: "12",
        height: "12",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3",
        strokeLinecap: "round",
        children: /* @__PURE__ */ jsx("line", { x1: "5", y1: "12", x2: "19", y2: "12" })
      }
    ) : /* @__PURE__ */ jsx(
      "svg",
      {
        "aria-hidden": "true",
        width: "12",
        height: "12",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /* @__PURE__ */ jsx("polyline", { points: "20 6 9 17 4 12" })
      }
    ) }),
    label && /* @__PURE__ */ jsx("span", { children: label })
  ] });
}
var _injected6 = false;
function ensureStyles6() {
  if (_injected6 || typeof document === "undefined") return;
  _injected6 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "switch");
  el.textContent = `
  .ramos-switch{display:inline-flex;align-items:center;gap:var(--space-5);font-family:var(--font-sans);font-size:var(--text-base);color:var(--text-body);cursor:pointer;user-select:none;}
  .ramos-switch input{position:absolute;opacity:0;width:0;height:0;}
  .ramos-switch__track{
    width:36px;height:20px;flex:none;border-radius:var(--radius-pill);
    background:var(--slate-300);position:relative;
    transition:background-color var(--duration-base) var(--ease-standard), box-shadow var(--duration-fast) var(--ease-standard);
  }
  .ramos-switch__thumb{
    position:absolute;top:2px;left:2px;width:16px;height:16px;border-radius:50%;
    background:#fff;box-shadow:var(--shadow-sm);
    transition:transform var(--duration-base) var(--ease-out);
  }
  .ramos-switch input:checked + .ramos-switch__track{background:var(--green-600);}
  .ramos-switch input:checked + .ramos-switch__track .ramos-switch__thumb{transform:translateX(16px);}
  .ramos-switch input:focus-visible + .ramos-switch__track{box-shadow:var(--ring);}
  .ramos-switch input:disabled + .ramos-switch__track{opacity:0.5;}
  .ramos-switch--sm .ramos-switch__track{width:30px;height:17px;}
  .ramos-switch--sm .ramos-switch__thumb{width:13px;height:13px;}
  .ramos-switch--sm input:checked + .ramos-switch__track .ramos-switch__thumb{transform:translateX(13px);}
  `;
  document.head.appendChild(el);
}
function Switch({
  label,
  size = "md",
  disabled = false,
  className = "",
  ...rest
}) {
  ensureStyles6();
  return /* @__PURE__ */ jsxs("label", { className: `ramos-switch${size === "sm" ? " ramos-switch--sm" : ""} ${className}`, children: [
    /* @__PURE__ */ jsx("input", { type: "checkbox", role: "switch", disabled, ...rest }),
    /* @__PURE__ */ jsx("span", { className: "ramos-switch__track", "aria-hidden": "true", children: /* @__PURE__ */ jsx("span", { className: "ramos-switch__thumb" }) }),
    label && /* @__PURE__ */ jsx("span", { children: label })
  ] });
}
var _injected7 = false;
function ensureStyles7() {
  if (_injected7 || typeof document === "undefined") return;
  _injected7 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "status-badge");
  el.textContent = `
  .ramos-status{
    display:inline-flex;align-items:center;gap:var(--space-3);
    font-family:var(--font-sans);font-size:var(--text-xs);font-weight:var(--weight-medium);
    line-height:1;padding:4px 8px 4px 7px;border-radius:var(--radius-sm);
    white-space:nowrap;letter-spacing:0.01em;
    color:var(--_fg);background:var(--_bg);
  }
  .ramos-status__dot{width:6px;height:6px;border-radius:50%;background:currentColor;flex:none;}
  .ramos-status--pending{--_fg:var(--status-pending-fg);--_bg:var(--status-pending-bg);}
  .ramos-status--transit{--_fg:var(--status-transit-fg);--_bg:var(--status-transit-bg);}
  .ramos-status--hold{--_fg:var(--status-hold-fg);--_bg:var(--status-hold-bg);}
  .ramos-status--delivered{--_fg:var(--status-delivered-fg);--_bg:var(--status-delivered-bg);}
  .ramos-status--exception{--_fg:var(--status-exception-fg);--_bg:var(--status-exception-bg);}
  .ramos-status--solid.ramos-status--pending{--_bg:var(--slate-500);--_fg:#fff;}
  .ramos-status--solid.ramos-status--transit{--_bg:var(--blue-600);--_fg:#fff;}
  .ramos-status--solid.ramos-status--hold{--_bg:var(--amber-600);--_fg:#fff;}
  .ramos-status--solid.ramos-status--delivered{--_bg:var(--green-600);--_fg:#fff;}
  .ramos-status--solid.ramos-status--exception{--_bg:var(--red-600);--_fg:#fff;}
  .ramos-status--pulse .ramos-status__dot{animation:ramos-pulse 1.6s var(--ease-standard) infinite;}
  @keyframes ramos-pulse{0%,100%{opacity:1;}50%{opacity:0.35;}}
  @media (prefers-reduced-motion: reduce){.ramos-status--pulse .ramos-status__dot{animation:none;}}
  `;
  document.head.appendChild(el);
}
var LABELS = {
  pending: "Pending",
  transit: "In transit",
  hold: "Customs hold",
  delivered: "Delivered",
  exception: "Exception"
};
function StatusBadge({
  status = "pending",
  label,
  dot = true,
  pulse = false,
  solid = false,
  className = "",
  children,
  ...rest
}) {
  ensureStyles7();
  const cls = [
    "ramos-status",
    `ramos-status--${status}`,
    solid && "ramos-status--solid",
    pulse && status === "transit" && "ramos-status--pulse",
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsxs("span", { className: cls, ...rest, children: [
    dot && /* @__PURE__ */ jsx("span", { className: "ramos-status__dot" }),
    children || label || LABELS[status]
  ] });
}
var _injected8 = false;
function ensureStyles8() {
  if (_injected8 || typeof document === "undefined") return;
  _injected8 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "tag");
  el.textContent = `
  .ramos-tag{
    display:inline-flex;align-items:center;gap:var(--space-3);
    font-family:var(--font-sans);font-size:var(--text-xs);font-weight:var(--weight-medium);
    line-height:1;padding:3px 8px;border-radius:var(--radius-pill);
    color:var(--text-body);background:var(--surface-sunken);
    border:var(--border-hairline) solid var(--border-default);white-space:nowrap;
  }
  .ramos-tag--harbor{color:var(--harbor-700);background:var(--harbor-50);border-color:var(--harbor-200);}
  .ramos-tag--cashew{color:var(--cashew-800);background:var(--cashew-50);border-color:var(--cashew-200);}
  .ramos-tag--outline{background:transparent;}
  .ramos-tag__x{display:inline-flex;cursor:pointer;color:var(--text-subtle);margin-right:-2px;border:0;background:none;padding:0;}
  .ramos-tag__x:hover{color:var(--text-body);}
  `;
  document.head.appendChild(el);
}
function Tag({
  color = "neutral",
  outline = false,
  onRemove,
  className = "",
  children,
  ...rest
}) {
  ensureStyles8();
  const cls = [
    "ramos-tag",
    color !== "neutral" && `ramos-tag--${color}`,
    outline && "ramos-tag--outline",
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsxs("span", { className: cls, ...rest, children: [
    children,
    onRemove && /* @__PURE__ */ jsx("button", { className: "ramos-tag__x", onClick: onRemove, "aria-label": "Remove", type: "button", children: /* @__PURE__ */ jsxs(
      "svg",
      {
        "aria-hidden": "true",
        width: "11",
        height: "11",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        children: [
          /* @__PURE__ */ jsx("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
          /* @__PURE__ */ jsx("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
        ]
      }
    ) })
  ] });
}
var _injected9 = false;
function ensureStyles9() {
  if (_injected9 || typeof document === "undefined") return;
  _injected9 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "card");
  el.textContent = `
  .ramos-card{
    background:var(--surface-card);border:var(--border-hairline) solid var(--border-default);
    border-radius:var(--radius-lg);box-shadow:var(--elevation-card);
    display:flex;flex-direction:column;font-family:var(--font-sans);overflow:hidden;
  }
  .ramos-card--flat{box-shadow:none;}
  .ramos-card--pad{padding:var(--space-7);}
  .ramos-card__head{
    display:flex;align-items:center;justify-content:space-between;gap:var(--space-5);
    padding:var(--space-6) var(--space-7);border-bottom:var(--border-hairline) solid var(--border-subtle);
  }
  .ramos-card__titles{display:flex;flex-direction:column;gap:2px;min-width:0;}
  .ramos-card__title{font:var(--font-section);color:var(--text-strong);margin:0;}
  .ramos-card__sub{font-size:var(--text-sm);color:var(--text-muted);}
  .ramos-card__actions{display:flex;align-items:center;gap:var(--space-4);flex:none;}
  .ramos-card__body{padding:var(--space-7);}
  .ramos-card__body--flush{padding:0;}
  `;
  document.head.appendChild(el);
}
function Card({
  title,
  subtitle,
  actions,
  flat = false,
  flush = false,
  padded = false,
  className = "",
  children,
  ...rest
}) {
  ensureStyles9();
  const hasHead = title || subtitle || actions;
  const cls = [
    "ramos-card",
    flat && "ramos-card--flat",
    !hasHead && padded && "ramos-card--pad",
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsxs("section", { className: cls, ...rest, children: [
    hasHead && /* @__PURE__ */ jsxs("header", { className: "ramos-card__head", children: [
      /* @__PURE__ */ jsxs("div", { className: "ramos-card__titles", children: [
        title && /* @__PURE__ */ jsx("h3", { className: "ramos-card__title", children: title }),
        subtitle && /* @__PURE__ */ jsx("span", { className: "ramos-card__sub", children: subtitle })
      ] }),
      actions && /* @__PURE__ */ jsx("div", { className: "ramos-card__actions", children: actions })
    ] }),
    hasHead ? /* @__PURE__ */ jsx("div", { className: `ramos-card__body${flush ? " ramos-card__body--flush" : ""}`, children }) : children
  ] });
}
var _injected10 = false;
function ensureStyles10() {
  if (_injected10 || typeof document === "undefined") return;
  _injected10 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "stat-card");
  el.textContent = `
  .ramos-stat{
    background:var(--surface-card);border:var(--border-hairline) solid var(--border-default);
    border-radius:var(--radius-md);padding:var(--space-6) var(--space-7);
    display:flex;flex-direction:column;gap:var(--space-4);font-family:var(--font-sans);min-width:0;
  }
  .ramos-stat__top{display:flex;align-items:center;justify-content:space-between;gap:var(--space-4);}
  .ramos-stat__label{font-size:var(--text-xs);font-weight:var(--weight-medium);color:var(--text-muted);text-transform:uppercase;letter-spacing:var(--tracking-label);}
  .ramos-stat__icon{display:flex;width:24px;height:24px;align-items:center;justify-content:center;border-radius:var(--radius-sm);background:var(--brand-subtle);color:var(--brand);flex:none;}
  .ramos-stat--tone-warning .ramos-stat__icon{background:color-mix(in srgb,var(--amber-600) 12%,transparent);color:var(--amber-600);}
  .ramos-stat--tone-danger .ramos-stat__icon{background:color-mix(in srgb,var(--red-600) 12%,transparent);color:var(--red-600);}
  .ramos-stat--tone-neutral .ramos-stat__icon{background:color-mix(in srgb,var(--slate-500) 12%,transparent);color:var(--slate-500);}
  .ramos-stat__value{font-family:var(--font-mono);font-weight:var(--weight-semibold);font-size:var(--text-3xl);color:var(--text-strong);line-height:1;font-variant-numeric:tabular-nums;letter-spacing:-0.01em;}
  .ramos-stat__value sup{font-size:var(--text-md);color:var(--text-muted);font-weight:var(--weight-medium);margin-left:3px;vertical-align:baseline;}
  .ramos-stat__foot{display:flex;align-items:center;gap:var(--space-3);font-size:var(--text-xs);color:var(--text-muted);}
  .ramos-stat__delta{display:inline-flex;align-items:center;gap:2px;font-weight:var(--weight-medium);}
  .ramos-stat__delta--up{color:var(--green-600);}
  .ramos-stat__delta--down{color:var(--red-600);}
  .ramos-stat__delta--flat{color:var(--text-muted);}
  `;
  document.head.appendChild(el);
}
var ARROWS = {
  up: /* @__PURE__ */ jsxs(
    "svg",
    {
      "aria-hidden": "true",
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx("line", { x1: "12", y1: "19", x2: "12", y2: "5" }),
        /* @__PURE__ */ jsx("polyline", { points: "5 12 12 5 19 12" })
      ]
    }
  ),
  down: /* @__PURE__ */ jsxs(
    "svg",
    {
      "aria-hidden": "true",
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx("line", { x1: "12", y1: "5", x2: "12", y2: "19" }),
        /* @__PURE__ */ jsx("polyline", { points: "19 12 12 19 5 12" })
      ]
    }
  )
};
function StatCard({
  label,
  value,
  unit,
  icon,
  tone = "brand",
  delta,
  trend = "flat",
  caption,
  className = "",
  ...rest
}) {
  ensureStyles10();
  return /* @__PURE__ */ jsxs("div", { className: `ramos-stat ramos-stat--tone-${tone} ${className}`, ...rest, children: [
    /* @__PURE__ */ jsxs("div", { className: "ramos-stat__top", children: [
      /* @__PURE__ */ jsx("span", { className: "ramos-stat__label", children: label }),
      icon && /* @__PURE__ */ jsx("span", { className: "ramos-stat__icon", children: icon })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "ramos-stat__value", children: [
      value,
      unit && /* @__PURE__ */ jsx("sup", { children: unit })
    ] }),
    (delta || caption) && /* @__PURE__ */ jsxs("div", { className: "ramos-stat__foot", children: [
      delta && /* @__PURE__ */ jsxs("span", { className: `ramos-stat__delta ramos-stat__delta--${trend}`, children: [
        ARROWS[trend],
        delta
      ] }),
      caption && /* @__PURE__ */ jsx("span", { children: caption })
    ] })
  ] });
}
var _injected11 = false;
function ensureStyles11() {
  if (_injected11 || typeof document === "undefined") return;
  _injected11 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "refid");
  el.textContent = `
  .ramos-refid{
    display:inline-flex;align-items:center;gap:var(--space-3);
    font-family:var(--font-mono);font-size:var(--text-sm);font-weight:var(--weight-medium);
    color:var(--text-strong);letter-spacing:0.01em;
    padding:2px 6px;border-radius:var(--radius-xs);
    background:var(--surface-sunken);border:var(--border-hairline) solid var(--border-subtle);
    white-space:nowrap;
  }
  .ramos-refid--plain{background:none;border:none;padding:0;}
  .ramos-refid__label{color:var(--text-subtle);font-family:var(--font-sans);font-size:var(--text-2xs);text-transform:uppercase;letter-spacing:var(--tracking-label);margin-right:2px;}
  .ramos-refid__copy{display:inline-flex;align-items:center;cursor:pointer;color:var(--text-subtle);border:none;background:none;padding:0;margin-left:2px;}
  .ramos-refid__copy:hover{color:var(--brand);}
  .ramos-refid__copy--ok{color:var(--green-600);}
  `;
  document.head.appendChild(el);
}
function RefId({
  value,
  prefix,
  copyable = false,
  plain = false,
  className = "",
  children,
  ...rest
}) {
  ensureStyles11();
  const text = value ?? (typeof children === "string" ? children : "");
  const [ok, setOk] = React5.useState(false);
  const copy = () => {
    try {
      navigator.clipboard?.writeText(text);
      setOk(true);
      setTimeout(() => setOk(false), 1200);
    } catch {
    }
  };
  return /* @__PURE__ */ jsxs("span", { className: `ramos-refid${plain ? " ramos-refid--plain" : ""} ${className}`, ...rest, children: [
    prefix && /* @__PURE__ */ jsx("span", { className: "ramos-refid__label", children: prefix }),
    children || value,
    copyable && /* @__PURE__ */ jsx(
      "button",
      {
        className: `ramos-refid__copy${ok ? " ramos-refid__copy--ok" : ""}`,
        onClick: copy,
        "aria-label": "Copy",
        type: "button",
        children: ok ? /* @__PURE__ */ jsx(
          "svg",
          {
            "aria-hidden": "true",
            width: "13",
            height: "13",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2.5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: /* @__PURE__ */ jsx("polyline", { points: "20 6 9 17 4 12" })
          }
        ) : /* @__PURE__ */ jsxs(
          "svg",
          {
            "aria-hidden": "true",
            width: "13",
            height: "13",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [
              /* @__PURE__ */ jsx("rect", { x: "9", y: "9", width: "13", height: "13", rx: "2" }),
              /* @__PURE__ */ jsx("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" })
            ]
          }
        )
      }
    )
  ] });
}
var _injected12 = false;
function ensureStyles12() {
  if (_injected12 || typeof document === "undefined") return;
  _injected12 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "milestone-tracker");
  el.textContent = `
  .ramos-track{font-family:var(--font-sans);display:flex;flex-direction:column;}
  /* vertical */
  .ramos-track--v .ramos-track__item{display:grid;grid-template-columns:auto 1fr;gap:var(--space-6);position:relative;padding-bottom:var(--space-7);}
  .ramos-track--v .ramos-track__item:last-child{padding-bottom:0;}
  .ramos-track--v .ramos-track__rail{display:flex;flex-direction:column;align-items:center;}
  .ramos-track--v .ramos-track__line{width:2px;flex:1;background:var(--border-default);margin-top:2px;border-radius:2px;}
  .ramos-track--v .ramos-track__item:last-child .ramos-track__line{display:none;}
  .ramos-track__dot{width:14px;height:14px;border-radius:50%;flex:none;border:2px solid var(--surface-card);box-shadow:0 0 0 2px var(--border-strong);background:var(--surface-card);display:flex;align-items:center;justify-content:center;color:#fff;}
  .ramos-track__dot svg{width:8px;height:8px;}
  .ramos-track__item--done .ramos-track__dot{background:var(--green-600);box-shadow:0 0 0 2px var(--green-600);}
  .ramos-track__item--done .ramos-track__line{background:var(--green-500);}
  .ramos-track__item--current .ramos-track__dot{background:var(--blue-600);box-shadow:0 0 0 2px var(--blue-600);}
  .ramos-track__item--current .ramos-track__dot::after{content:"";position:absolute;width:14px;height:14px;border-radius:50%;box-shadow:0 0 0 4px var(--blue-100);}
  .ramos-track__item--exception .ramos-track__dot{background:var(--red-600);box-shadow:0 0 0 2px var(--red-600);}
  .ramos-track__item--upcoming .ramos-track__dot{background:var(--surface-card);box-shadow:0 0 0 2px var(--border-strong);}
  .ramos-track__body{padding-top:-1px;min-width:0;}
  .ramos-track__label{font-size:var(--text-sm);font-weight:var(--weight-semibold);color:var(--text-strong);}
  .ramos-track__item--upcoming .ramos-track__label{color:var(--text-muted);font-weight:var(--weight-medium);}
  .ramos-track__meta{display:flex;flex-wrap:wrap;gap:var(--space-3) var(--space-5);margin-top:3px;font-size:var(--text-xs);color:var(--text-muted);}
  .ramos-track__loc{display:inline-flex;align-items:center;gap:3px;}
  .ramos-track__time{font-family:var(--font-mono);font-variant-numeric:tabular-nums;}
  .ramos-track__code{font-family:var(--font-mono);color:var(--text-subtle);}
  /* horizontal */
  .ramos-track--h{flex-direction:row;}
  .ramos-track--h .ramos-track__item{flex:1;display:flex;flex-direction:column;gap:var(--space-4);position:relative;padding:0;}
  .ramos-track--h .ramos-track__rail{display:flex;align-items:center;}
  .ramos-track--h .ramos-track__line{height:2px;flex:1;background:var(--border-default);margin-left:var(--space-3);border-radius:2px;}
  .ramos-track--h .ramos-track__item:last-child .ramos-track__line{display:none;}
  .ramos-track--h .ramos-track__item--done .ramos-track__line{background:var(--green-500);}
  .ramos-track--h .ramos-track__body{padding:0;}
  .ramos-track--h .ramos-track__label{font-size:var(--text-xs);}
  `;
  document.head.appendChild(el);
}
var CHECK = /* @__PURE__ */ jsx(
  "svg",
  {
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: /* @__PURE__ */ jsx("polyline", { points: "20 6 9 17 4 12" })
  }
);
var BANG = /* @__PURE__ */ jsxs(
  "svg",
  {
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    strokeLinecap: "round",
    children: [
      /* @__PURE__ */ jsx("line", { x1: "12", y1: "6", x2: "12", y2: "13" }),
      /* @__PURE__ */ jsx("line", { x1: "12", y1: "17", x2: "12", y2: "17" })
    ]
  }
);
function MilestoneTracker({
  milestones = [],
  orientation = "vertical",
  className = "",
  ...rest
}) {
  ensureStyles12();
  const o = orientation === "horizontal" ? "h" : "v";
  return /* @__PURE__ */ jsx("div", { className: `ramos-track ramos-track--${o} ${className}`, ...rest, children: milestones.map((m) => /* @__PURE__ */ jsxs(
    "div",
    {
      className: `ramos-track__item ramos-track__item--${m.state || "upcoming"}`,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "ramos-track__rail", children: [
          /* @__PURE__ */ jsxs("span", { className: "ramos-track__dot", children: [
            m.state === "done" && CHECK,
            m.state === "exception" && BANG
          ] }),
          /* @__PURE__ */ jsx("span", { className: "ramos-track__line" })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "ramos-track__body", children: [
          /* @__PURE__ */ jsx("div", { className: "ramos-track__label", children: m.label }),
          /* @__PURE__ */ jsxs("div", { className: "ramos-track__meta", children: [
            m.location && /* @__PURE__ */ jsxs("span", { className: "ramos-track__loc", children: [
              m.location,
              m.code && /* @__PURE__ */ jsxs("span", { className: "ramos-track__code", children: [
                "\xB7",
                m.code
              ] })
            ] }),
            m.time && /* @__PURE__ */ jsx("span", { className: "ramos-track__time", children: m.time })
          ] })
        ] })
      ]
    },
    m.label
  )) });
}
var _injected13 = false;
function ensureStyles13() {
  if (_injected13 || typeof document === "undefined") return;
  _injected13 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "empty-state");
  el.textContent = `
  .ramos-empty{
    display:flex;flex-direction:column;align-items:center;text-align:center;
    gap:var(--space-5);padding:var(--space-11) var(--space-8);font-family:var(--font-sans);
  }
  .ramos-empty__icon{
    width:48px;height:48px;border-radius:var(--radius-lg);
    display:flex;align-items:center;justify-content:center;
    background:var(--surface-sunken);color:var(--text-subtle);
    border:var(--border-hairline) solid var(--border-default);
  }
  .ramos-empty__title{font-size:var(--text-md);font-weight:var(--weight-semibold);color:var(--text-strong);}
  .ramos-empty__desc{font-size:var(--text-sm);color:var(--text-muted);max-width:340px;line-height:var(--leading-snug);}
  .ramos-empty__action{margin-top:var(--space-3);}
  `;
  document.head.appendChild(el);
}
function EmptyState({
  icon,
  title,
  description,
  action,
  className = "",
  ...rest
}) {
  ensureStyles13();
  return /* @__PURE__ */ jsxs("div", { className: `ramos-empty ${className}`, ...rest, children: [
    icon && /* @__PURE__ */ jsx("div", { className: "ramos-empty__icon", children: icon }),
    title && /* @__PURE__ */ jsx("div", { className: "ramos-empty__title", children: title }),
    description && /* @__PURE__ */ jsx("div", { className: "ramos-empty__desc", children: description }),
    action && /* @__PURE__ */ jsx("div", { className: "ramos-empty__action", children: action })
  ] });
}
var _injected14 = false;
function ensureStyles14() {
  if (_injected14 || typeof document === "undefined") return;
  _injected14 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "toast");
  el.textContent = `
  .ramos-toast{
    display:flex;align-items:flex-start;gap:var(--space-5);
    width:360px;max-width:calc(100vw - 32px);
    background:var(--surface-card);border:var(--border-hairline) solid var(--border-default);
    border-left:3px solid var(--_accent,var(--brand));
    border-radius:var(--radius-md);box-shadow:var(--elevation-toast);
    padding:var(--space-5) var(--space-6);font-family:var(--font-sans);
  }
  .ramos-toast__icon{display:flex;flex:none;margin-top:1px;color:var(--_accent,var(--brand));}
  .ramos-toast__main{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px;}
  .ramos-toast__title{font-size:var(--text-sm);font-weight:var(--weight-semibold);color:var(--text-strong);}
  .ramos-toast__msg{font-size:var(--text-xs);color:var(--text-muted);line-height:var(--leading-snug);}
  .ramos-toast__close{flex:none;border:none;background:none;cursor:pointer;color:var(--text-subtle);padding:0;display:flex;margin-top:1px;}
  .ramos-toast__close:hover{color:var(--text-body);}
  .ramos-toast--success{--_accent:var(--green-600);}
  .ramos-toast--error{--_accent:var(--red-600);}
  .ramos-toast--warning{--_accent:var(--amber-600);}
  .ramos-toast--info{--_accent:var(--blue-600);}
  `;
  document.head.appendChild(el);
}
var ICONS = {
  success: /* @__PURE__ */ jsxs(
    "svg",
    {
      "aria-hidden": "true",
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }),
        /* @__PURE__ */ jsx("polyline", { points: "22 4 12 14.01 9 11.01" })
      ]
    }
  ),
  error: /* @__PURE__ */ jsxs(
    "svg",
    {
      "aria-hidden": "true",
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12", r: "10" }),
        /* @__PURE__ */ jsx("line", { x1: "12", y1: "8", x2: "12", y2: "12" }),
        /* @__PURE__ */ jsx("line", { x1: "12", y1: "16", x2: "12", y2: "16" })
      ]
    }
  ),
  warning: /* @__PURE__ */ jsxs(
    "svg",
    {
      "aria-hidden": "true",
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }),
        /* @__PURE__ */ jsx("line", { x1: "12", y1: "9", x2: "12", y2: "13" }),
        /* @__PURE__ */ jsx("line", { x1: "12", y1: "17", x2: "12", y2: "17" })
      ]
    }
  ),
  info: /* @__PURE__ */ jsxs(
    "svg",
    {
      "aria-hidden": "true",
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12", r: "10" }),
        /* @__PURE__ */ jsx("line", { x1: "12", y1: "16", x2: "12", y2: "12" }),
        /* @__PURE__ */ jsx("line", { x1: "12", y1: "8", x2: "12", y2: "8" })
      ]
    }
  )
};
function Toast({
  variant = "info",
  title,
  message,
  onClose,
  className = "",
  ...rest
}) {
  ensureStyles14();
  return (
    // biome-ignore lint/a11y/useSemanticElements: role="status" is the conventional live-region pattern for a transient toast; <output> implies form-calculation output, which this is not.
    /* @__PURE__ */ jsxs("div", { className: `ramos-toast ramos-toast--${variant} ${className}`, role: "status", ...rest, children: [
      /* @__PURE__ */ jsx("span", { className: "ramos-toast__icon", children: ICONS[variant] }),
      /* @__PURE__ */ jsxs("div", { className: "ramos-toast__main", children: [
        title && /* @__PURE__ */ jsx("span", { className: "ramos-toast__title", children: title }),
        message && /* @__PURE__ */ jsx("span", { className: "ramos-toast__msg", children: message })
      ] }),
      onClose && /* @__PURE__ */ jsx("button", { className: "ramos-toast__close", onClick: onClose, "aria-label": "Dismiss", type: "button", children: /* @__PURE__ */ jsxs(
        "svg",
        {
          "aria-hidden": "true",
          width: "14",
          height: "14",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          children: [
            /* @__PURE__ */ jsx("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
            /* @__PURE__ */ jsx("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
          ]
        }
      ) })
    ] })
  );
}
var _injected15 = false;
function ensureStyles15() {
  if (_injected15 || typeof document === "undefined") return;
  _injected15 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "tooltip");
  el.textContent = `
  .ramos-tip{position:relative;display:inline-flex;}
  .ramos-tip__pop{
    position:absolute;z-index:var(--z-overlay);
    background:var(--harbor-900);color:#fff;font-family:var(--font-sans);
    font-size:var(--text-xs);font-weight:var(--weight-medium);line-height:1.3;
    padding:5px 9px;border-radius:var(--radius-sm);white-space:nowrap;
    box-shadow:var(--shadow-md);pointer-events:none;
    opacity:0;transform:translateY(2px);
    transition:opacity var(--duration-fast) var(--ease-standard), transform var(--duration-fast) var(--ease-standard);
  }
  .ramos-tip:hover .ramos-tip__pop, .ramos-tip:focus-within .ramos-tip__pop{opacity:1;transform:translateY(0);}
  .ramos-tip__pop--top{bottom:calc(100% + 7px);left:50%;transform:translate(-50%,2px);}
  .ramos-tip:hover .ramos-tip__pop--top{transform:translate(-50%,0);}
  .ramos-tip__pop--bottom{top:calc(100% + 7px);left:50%;transform:translate(-50%,-2px);}
  .ramos-tip:hover .ramos-tip__pop--bottom{transform:translate(-50%,0);}
  .ramos-tip__pop--right{left:calc(100% + 7px);top:50%;transform:translate(-2px,-50%);}
  .ramos-tip:hover .ramos-tip__pop--right{transform:translate(0,-50%);}
  .ramos-tip__arrow{position:absolute;width:6px;height:6px;background:var(--harbor-900);transform:rotate(45deg);}
  .ramos-tip__pop--top .ramos-tip__arrow{bottom:-3px;left:50%;margin-left:-3px;}
  .ramos-tip__pop--bottom .ramos-tip__arrow{top:-3px;left:50%;margin-left:-3px;}
  .ramos-tip__pop--right .ramos-tip__arrow{left:-3px;top:50%;margin-top:-3px;}
  `;
  document.head.appendChild(el);
}
function Tooltip({
  content,
  placement = "top",
  className = "",
  children,
  ...rest
}) {
  ensureStyles15();
  return (
    // biome-ignore lint/a11y/noNoninteractiveTabindex: the wrapper is intentionally focusable so keyboard users surface the tooltip via the CSS :focus-within rule.
    /* @__PURE__ */ jsxs("span", { className: `ramos-tip ${className}`, tabIndex: 0, ...rest, children: [
      children,
      /* @__PURE__ */ jsxs("span", { className: `ramos-tip__pop ramos-tip__pop--${placement}`, role: "tooltip", children: [
        content,
        /* @__PURE__ */ jsx("span", { className: "ramos-tip__arrow" })
      ] })
    ] })
  );
}
var _injected16 = false;
function ensureStyles16() {
  if (_injected16 || typeof document === "undefined") return;
  _injected16 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "sidebar-nav");
  el.textContent = `
  .ramos-nav{display:flex;flex-direction:column;gap:var(--space-2);font-family:var(--font-sans);}
  .ramos-nav__section{font-size:var(--text-2xs);font-weight:var(--weight-semibold);color:var(--text-subtle);text-transform:uppercase;letter-spacing:var(--tracking-label);padding:var(--space-5) var(--space-5) var(--space-3);}
  .ramos-nav__item{
    display:flex;align-items:center;gap:var(--space-5);
    padding:var(--space-4) var(--space-5);border-radius:var(--radius-sm);
    font-size:var(--text-sm);font-weight:var(--weight-medium);color:var(--text-body);
    cursor:pointer;text-decoration:none;border:none;background:none;width:100%;text-align:left;
    transition:var(--transition-colors);position:relative;
  }
  .ramos-nav__item:hover{background:var(--surface-hover);color:var(--text-strong);}
  .ramos-nav__item--active{background:var(--surface-selected);color:var(--brand);font-weight:var(--weight-semibold);}
  .ramos-nav__item--active::before{content:"";position:absolute;left:0;top:6px;bottom:6px;width:3px;border-radius:0 2px 2px 0;background:var(--brand);}
  .ramos-nav__icon{display:flex;align-items:center;justify-content:center;width:18px;height:18px;flex:none;color:currentColor;}
  .ramos-nav__label{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
  .ramos-nav__badge{
    font-family:var(--font-mono);font-size:var(--text-2xs);font-weight:var(--weight-medium);
    background:var(--surface-sunken);color:var(--text-muted);padding:1px 6px;border-radius:var(--radius-pill);
    font-variant-numeric:tabular-nums;flex:none;
  }
  .ramos-nav__item--active .ramos-nav__badge{background:var(--brand-subtle);color:var(--brand);}
  .ramos-nav__badge--alert{background:var(--status-exception-bg);color:var(--status-exception-fg);}
  `;
  document.head.appendChild(el);
}
function SidebarNav({
  items = [],
  activeId,
  onSelect,
  className = "",
  ...rest
}) {
  ensureStyles16();
  return /* @__PURE__ */ jsx("nav", { className: `ramos-nav ${className}`, ...rest, children: items.map((it) => {
    if (it.section)
      return /* @__PURE__ */ jsx("div", { className: "ramos-nav__section", children: it.section }, `section-${it.section}`);
    const active = it.id === activeId;
    const cls = `ramos-nav__item${active ? " ramos-nav__item--active" : ""}`;
    const inner = /* @__PURE__ */ jsxs(Fragment, { children: [
      it.icon && /* @__PURE__ */ jsx("span", { className: "ramos-nav__icon", children: it.icon }),
      /* @__PURE__ */ jsx("span", { className: "ramos-nav__label", children: it.label }),
      it.badge != null && /* @__PURE__ */ jsx("span", { className: `ramos-nav__badge${it.alert ? " ramos-nav__badge--alert" : ""}`, children: it.badge })
    ] });
    if (it.href !== void 0) {
      return /* @__PURE__ */ jsx(
        "a",
        {
          href: it.href,
          onClick: it.onClick,
          className: cls,
          "aria-current": active ? "page" : void 0,
          children: inner
        },
        it.id ?? it.href
      );
    }
    return /* @__PURE__ */ jsx(
      "button",
      {
        className: cls,
        onClick: () => {
          if (it.id != null) onSelect?.(it.id);
        },
        "aria-current": active ? "page" : void 0,
        type: "button",
        children: inner
      },
      it.id
    );
  }) });
}
var _injected17 = false;
function ensureStyles17() {
  if (_injected17 || typeof document === "undefined") return;
  _injected17 = true;
  const el = document.createElement("style");
  el.setAttribute("data-ramos", "tabs");
  el.textContent = `
  .ramos-tabs{display:flex;align-items:center;gap:var(--space-2);font-family:var(--font-sans);border-bottom:var(--border-hairline) solid var(--border-default);}
  .ramos-tab{
    position:relative;display:inline-flex;align-items:center;gap:var(--space-4);
    padding:var(--space-5) var(--space-5) calc(var(--space-5) - 1px);
    font-size:var(--text-sm);font-weight:var(--weight-medium);color:var(--text-muted);
    background:none;border:none;cursor:pointer;white-space:nowrap;
    border-bottom:2px solid transparent;margin-bottom:-1px;
    transition:var(--transition-colors);
  }
  .ramos-tab:hover{color:var(--text-body);}
  .ramos-tab--active{color:var(--brand);border-bottom-color:var(--brand);}
  .ramos-tab:focus-visible{outline:none;box-shadow:var(--ring);border-radius:var(--radius-xs);}
  .ramos-tab__count{
    font-family:var(--font-mono);font-size:var(--text-2xs);font-weight:var(--weight-medium);
    background:var(--surface-sunken);color:var(--text-muted);
    padding:1px 5px;border-radius:var(--radius-pill);font-variant-numeric:tabular-nums;
  }
  .ramos-tab--active .ramos-tab__count{background:var(--brand-subtle);color:var(--brand);}
  `;
  document.head.appendChild(el);
}
function Tabs({
  tabs = [],
  value,
  defaultValue,
  onChange,
  className = "",
  ...rest
}) {
  ensureStyles17();
  const [internal, setInternal] = React5.useState(defaultValue ?? tabs[0]?.id);
  const active = value !== void 0 ? value : internal;
  const select = (id) => {
    if (value === void 0) setInternal(id);
    onChange?.(id);
  };
  return /* @__PURE__ */ jsx("div", { className: `ramos-tabs ${className}`, role: "tablist", ...rest, children: tabs.map((t) => /* @__PURE__ */ jsxs(
    "button",
    {
      role: "tab",
      "aria-selected": active === t.id,
      className: `ramos-tab${active === t.id ? " ramos-tab--active" : ""}`,
      onClick: () => select(t.id),
      type: "button",
      children: [
        t.label,
        t.count != null && /* @__PURE__ */ jsx("span", { className: "ramos-tab__count", children: t.count })
      ]
    },
    t.id
  )) });
}

export { Button, Card, Checkbox, EmptyState, IconButton, Input, MilestoneTracker, RefId, Select, SidebarNav, StatCard, StatusBadge, Switch, Tabs, Tag, Toast, Tooltip };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map